import React from 'react';
// Update the import path below to the correct location if different
import { PlmEventList } from './plmEvent-list';
// Update the import path below to the correct location if different
// Update the import path below to the correct location if different
import { useIsSmallScreen } from '../../../system/SystemMediaQueriesProvider';

export function PlmEventMain() {
  const isSmall = useIsSmallScreen();

  return (
    <div
      style={{
        margin: isSmall ? '0px' : '10px',
        display: 'flex',
        flexDirection: 'row',
        flex: 1,
        alignItems: 'stretch',
      }}
    >
      <PlmEventList />
    </div>
  );
}
